import { useUser } from 'shared/hooks/user/useUser';
import { UserRole } from 'shared/types';

const { REACT_APP_USER_ROLE: userRole } = process.env;

export const useUserRole = (): UserRole => {
  const user = useUser();

  if (user?.accountType === 'ParentOrGuardian') {
    return UserRole.Parent;
  }

  if (user?.accountType === 'Staff') {
    return UserRole.Staff;
  }

  if (user?.accountType === 'Admin') {
    return UserRole.Admin;
  }

  return userRole || UserRole.Student;
};
